import script from "./Sidenav.vue?vue&type=script&setup=true&lang=js"
export * from "./Sidenav.vue?vue&type=script&setup=true&lang=js"

import "./Sidenav.vue?vue&type=style&index=0&id=69c955cb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69c955cb"]])

export default __exports__